import {Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {TopNavbarComponent} from './components/layout/top-navbar/top-navbar.component';
import {LeftNavbarComponent} from './components/layout/left-navbar/left-navbar.component';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {AuthService} from './services/auth/auth.service';
import {LoaderComponent} from './components/layout/loader/loader.component';
import {SnackbarComponent} from './components/layout/snackbar/snackbar.component';
import {DialogModalComponent} from './components/layout/dialog-modal/dialog-modal.component';
import {LeftNavbarService} from './services/left-navbar/left-navbar.service';
import {ConfirmModalComponent} from './components/layout/confirm-modal/confirm-modal.component';
import {environment} from '../environments/environment';
import {TranslateService} from "@ngx-translate/core";
import {UserActivityService} from './services/user-activity/user-activity.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TopNavbarComponent, LeftNavbarComponent, NgTemplateOutlet, LoaderComponent, SnackbarComponent, DialogModalComponent, NgClass, ConfirmModalComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  constructor(
    public leftNavbarService: LeftNavbarService,
    private auth: AuthService,
    private router: Router,
    private translate: TranslateService,
    private userActivity: UserActivityService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.translate.addLangs(['en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');

    const link = this.document.createElement('link');
    link.rel = 'preconnect';
    link.href = environment.server.url;
    this.document.head.appendChild(link);
  }

  ngOnInit(): void {
    document.addEventListener('hide.bs.modal', (event: Event) => {
      const activeElement = document.activeElement;
      if (activeElement instanceof HTMLElement && (event.target as HTMLElement).contains(activeElement)) {
        activeElement.blur();
      }
    });

    this.userActivity.trackNavigation();

    this.router.events.subscribe((data) => {
      if (data instanceof NavigationEnd) {
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    });
  }

  isLogged(): boolean {
    return this.auth.isLogged();
  }
}
